import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal, ModalBody, ModalFooter, Button } from 'reactstrap';
import { close } from 'redux/modules/modals/actions';

class Wrapper extends Component {
    handleConfirm = () => {
        this.props.onConfirm();
        if (this.props.closeOnSuccess) {
            this.props.close();
        }
    };

    render() {
        const { close, confirmButtonTitle, children } = this.props;

        return (
            <div
                onKeyUp={(e) => {
                    if (e.key === 'Escape') {
                        close();
                    }
                }}
                tabIndex={0}
            >
                <Modal className="delete-confirm" isOpen={true} fade={false} style={{ padding: '40vh 0'}}>
                    <ModalBody>
                        <Button style={{ height: 'auto' }} className="close" onClick={close}>
                            <span aria-hidden="true">×</span>
                        </Button>
                        {children}
                    </ModalBody>
                    <ModalFooter>
                        <Button style={{ color: 'white' }} onClick={close}>
                            Cancel
                        </Button>
                        <Button onClick={this.handleConfirm} className="btn typical-button">
                            {confirmButtonTitle}
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

Wrapper.propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
};

Wrapper.defaultProps = {
    confirmButtonTitle: 'Ok',
    closeOnSuccess: true,
};

export default connect(
    null,
    { close }
)(Wrapper);
